import { IconProps } from "@/data/types"

export default function ArrowOutwardIcon({ width=24, height=24, color='#A58760', className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 15.5L15.5 0.5M15.5 0.5H3.3125M15.5 0.5V12.6875" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  )
}